/**
 * Labstep
 */

import { List } from 'labstep-web/core/List';
import { MediaQueryDesktop as Desktop } from 'labstep-web/core/MediaQuery/Desktop';
import { NumberCircle } from 'labstep-web/core/Number/Circle';
import type React from 'react';
import styles from './styles.module.scss';
import type { IModalWizardHeaderStepProps } from './types';

export const ModalWizardHeaderStep: React.FC<
  IModalWizardHeaderStepProps
> = ({ step, number, active, complete, hideStepName }) => (
  <List.Item>
    <Desktop>
      {({ match }) => (
        <div className={styles.step}>
          <NumberCircle
            number={number}
            primary={active}
            complete={complete}
          />
          {match && !hideStepName ? (
            <span className={styles.stepText}>{step}</span>
          ) : null}
        </div>
      )}
    </Desktop>
  </List.Item>
);
